import { createRouter, createWebHashHistory } from 'vue-router'
import { rootRoute } from '@/router/routes'
// import { getToken } from '@/utils/auth'
// import { ElMessage } from 'element-plus'
// import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { recursion } from '@/utils/tools'

// 创建路由实例并传递 `routes` 配置
const router = createRouter({
  history: createWebHashHistory(),
  routes: rootRoute as unknown as RouteRecordRaw[]
})

// 获取router meta中isIframe为true的路由
const hasOpenComponentsArr = () => {
  const componentsArr: Recordable = []
  recursion(rootRoute, item => {
    if (item.meta?.isIFrame) {
      componentsArr.push({
        path: item.path,
        name: item.name,
        component: item.iframeComponent
      })
    }
  })
  return componentsArr
}

export function setupRouter(app: App) {
  app.use(router)
  hasOpenComponentsArr().forEach((item: any) => {
    app.component(item.name, item.component)
  })
}

export { router, hasOpenComponentsArr }
